import { addAndTrack } from "../../../calculators/helpers";
import { findByCode } from "../../../helpers";
import { Green } from "../../../styledCpns/DataDisplay";
import { GrayStats, GreenStats, wpSimpleAnTmaker } from "../config";
import { BaneSeries1 } from "../series";

const OtherCatalysts = [
  {
    code: 128,
    name: "Otherworldly Story",
    icon: "1/11/Weapon_Otherworldly_Story",
    rarity: 3,
    mainStatScale: 39,
    subStat: { type: "Energy Recharge", scale: "8.5%" },
    pasvName: "Energy Shower",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            Each Elemental Orb or Particle collected restores{" "}
            {0.75 + wpRfm * 0.25}% HP.
          </>
        )
      }
    ]
  },
  {
    code: 27,
    name: "Emerald Orb",
    icon: "7/7c/Weapon_Emerald_Orb",
    rarity: 3,
    mainStatScale: 40,
    subStat: { type: "Elemental Mastery", scale: 20 },
    buffs: [
      {
        index: 0,
        affect: "self",
        addBnes: wpSimpleAnTmaker("ATTRs", "ATK%", 5),
        desc: ({ wpRfm }) =>
          findByCode(OtherCatalysts, 27).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Rapids",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            Upon causing a Vaporize, Electro-Charged, Frozen, or a Hydro-infused
            Swirl reaction, increases <Green>ATK</Green> by{" "}
            <Green b>{15 + wpRfm * 5}%</Green> for 12s.
          </>
        )
      }
    ]
  },
  {
    code: 28,
    name: "Twin Nephrite",
    icon: "e/e3/Weapon_Twin_Nephrite",
    rarity: 3,
    mainStatScale: 40,
    subStat: { type: "CRIT Rate", scale: "3.4%" },
    buffs: [
      {
        index: 0,
        affect: "self",
        addBnes: ({ ATTRs, wpRfm, tkDesc, tracker }) => {
          addAndTrack(tkDesc, ATTRs, "ATK%", 10 + wpRfm * 2, tracker);
        },
        desc: ({ wpRfm }) =>
          findByCode(OtherCatalysts, 28).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Rapids",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            Defeating an opponent increases Movement SPD and <Green>ATK</Green>{" "}
            by <Green b>{10 + wpRfm * 2}%</Green> for 15s.
          </>
        )
      }
    ]
  },
  {
    code: 29,
    name: "Thrilling Tales of Dragon Slayers",
    icon: "1/19/Weapon_Thrilling_Tales_of_Dragon_Slayers",
    rarity: 3,
    mainStatScale: 39,
    subStat: { type: "HP%", scale: "7.7%" },
    buffs: [
      {
        index: 0,
        affect: "teammates",
        addBnes: wpSimpleAnTmaker("ATTRs", "ATK%", 6),
        desc: ({ wpRfm }) =>
          findByCode(OtherCatalysts, 29).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Legacy",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            When switching characters, the new character taking the field has
            their <Green>ATK</Green> increased by{" "}
            <Green b>{18 + wpRfm * 6}%</Green> for 10s. This effect can only
            occur once every 20s.
          </>
        )
      }
    ]
  },
  {
    code: 30,
    name: "Magic Guide",
    icon: "3/39/Weapon_Magic_Guide",
    rarity: 3,
    mainStatScale: 38,
    subStat: { type: "Elemental Mastery", scale: 41 },
    ...BaneSeries1("Storm and Tide", "Hydro or Electro")
  },
  {
    code: 35,
    name: "Pocket Grimoire",
    icon: "1/16/Weapon_Pocket_Grimoire",
    ...GreenStats
  },
  {
    code: 36,
    name: "Apprentice's Notes",
    icon: "c/cf/Weapon_Apprentice%27s_Notes",
    ...GrayStats
  }
];

export default OtherCatalysts;
